module.exports = __webpack_public_path__ + "images/background/theme_thumbnail/3-on-f6a0d19cd37cff8459725af1f9c3a05a.png";